import { Component, OnDestroy, OnInit } from '@angular/core';
import { LocalStorageService } from '../../../../../core/services/localStorage.service';
import { AccountSelectionService } from '../../account/components/login-form/account-selection/account-selection.service';
import { SoldToModalComponent } from '../../account/components/login-form/sold-to-modal/sold-to-modal.component';
import { ShipToModalComponent } from '../../account/components/login-form/ship-to-modal/ship-to-modal.component';
import { BehaviorSubject, distinctUntilChanged, Subscription, switchMap } from 'rxjs';
import { MenuMobileService } from '../../../store-front/misc/header/menu-mobile.service';

@Component({
  selector: 'cx-my-account',
  templateUrl: './my-account.component.html',
  styleUrl: './my-account.component.scss',
  standalone: false,
})
export class MyAccountComponent implements OnInit, OnDestroy {
  selectedAccount$ = new BehaviorSubject('');
  selectedAddress$ = new BehaviorSubject('');
  orgUnit$ = this.accountSelectionService.getCurrent();
  addressAccounts$ = new BehaviorSubject([]);
  subscription = new Subscription();

  constructor(
    protected localStorageService: LocalStorageService,
    protected accountSelectionService: AccountSelectionService,
    protected menuMobileService: MenuMobileService,
  ) {}

  ngOnInit(): void {
    this.handleStore();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  handleStore() {
    this.accountSelectionService.fetch();

    this.subscription.add(
      this.accountSelectionService.get().subscribe(selectedAccount => {
        this.selectedAccount$.next(selectedAccount?.displayAccount);
        this.selectedAddress$.next(selectedAccount?.displayAddress);
      }),
    );
    this.subscription.add(
      this.selectedAddress$
        .pipe(
          distinctUntilChanged(),
          switchMap(() => this.accountSelectionService.getUserAddresByLocalStorageSelectedAccount()),
        )
        .subscribe(addressAccounts => {
          this.addressAccounts$.next(addressAccounts);
        }),
    );
  }

  openSoldToModal() {
    this.accountSelectionService.openSelectionModal(SoldToModalComponent, 'sold-to-modal', false);
    this.menuMobileService.close();
    this.accountSelectionService.handleSelectedBackup();
  }

  openShipToModal() {
    this.accountSelectionService.openSelectionModal(ShipToModalComponent, 'ship-to-modal', false);
    this.menuMobileService.close();
    this.accountSelectionService.handleSelectedBackup();
  }

  handleSelectedBackup() {
    this.accountSelectionService.handleSelectedBackup();
  }
}
